import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoPopupComponent } from '../video-popup/video-popup.component';

@Component({
  selector: 'sbc-exhibitor-presentations',
  templateUrl: './presentations.component.html',
  styleUrls: ['./presentations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationsComponent implements OnInit {
  private _exhibitor!: ExhibitorEntry;
  iframeMobileVisible = false;
  awaitingVimeoApiResponse = false;

  @Input()
  set exhibitor(exhibitor: ExhibitorEntry) {
    this._exhibitor = exhibitor;
    this.iframeMobileVisible = false;
    this.loadVideo();
  };

  get exhibitor(): ExhibitorEntry {
    return this._exhibitor;
  }

  constructor(private http: HttpClient, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer, private matDialog: MatDialog) {}

  loadVideo() {
    if (this.exhibitor?.video) {
      const videoUrl = this.exhibitor.video.url;
      if (videoUrl.includes('youtube.com') || videoUrl.includes('youtu.be')) {
        try {
          const url = new URL(videoUrl);
          let videoId = url.searchParams.get('v') || url.pathname.replace('/', '');
          this.exhibitor.video.thumbnailSrc = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
          this.exhibitor.video.iframe = this.sanitizer.bypassSecurityTrustHtml(`<iframe style="max-width: 100%;" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen="false"></iframe>`);
        } catch (error) {
          console.error(error);
        }
        return;
      }
      if (videoUrl.includes('vimeo.com')) {
        this.awaitingVimeoApiResponse = true;
        this.http.get(`https://vimeo.com/api/oembed.json?url=${videoUrl}`).subscribe((info: any) => {
          this.exhibitor.video!.thumbnailSrc = info.thumbnail_url;
          this.exhibitor.video!.iframe = this.sanitizer.bypassSecurityTrustHtml(info.html);
          this.awaitingVimeoApiResponse = false;
          this.cdr.detectChanges();
        });
        return;
      }
      this.exhibitor.video.invalid = true;
    }
  }

  onPlay() {
    if (window.innerWidth < 800) {
      this.iframeMobileVisible = true;
    } else {
      this.matDialog.open(VideoPopupComponent, {
        data: {
          title: this.exhibitor.video?.displayText,
          iframe: this.exhibitor.video?.iframe,
        },
        maxWidth: 1188,
        width: '100%'
      });
    }
  }

  ngOnInit(): void {
    this.loadVideo();
  }

}
